export default "__VITE_ASSET__DFHafOlj__";